import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
  OnInit,
  PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  lucideCheck,
  lucideLoader2,
  lucideArrowRight,
  lucideMail,
  lucideShieldCheck,
  lucideBuilding2,
  lucideHome,
  lucideArrowLeft,
  lucideXCircle
} from '@ng-icons/lucide';
import { ZardButtonComponent } from '../../../shared/components/button';
import { NgOptimizedImage } from '@angular/common';
import { UserService } from '../../../core/auth/services/user.service';
import { take } from 'rxjs';

@Component({
  selector: 'app-account-verified',
  standalone: true,
  imports: [NgIcon, ZardButtonComponent, NgOptimizedImage],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    provideIcons({
      lucideCheck,
      lucideLoader2,
      lucideArrowRight,
      lucideMail,
      lucideShieldCheck,
      lucideBuilding2,
      lucideHome,
      lucideArrowLeft,
      lucideXCircle
    })
  ],
  templateUrl: './account-verified.component.html',
})
export class AccountVerifiedComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private userService = inject(UserService);

  readonly name = signal<string>('');
  readonly email = signal<string>('');

  readonly status = signal<'verifying' | 'verified' | 'error'>('verifying');
  readonly errorMessage = signal<string>('');

  readonly firstName = computed(() => {
    const nameVal = this.name();
    return nameVal ? nameVal.trim().split(' ')[0] : '';
  });

  readonly steps = [
    { icon: 'lucideShieldCheck', label: 'Adresse e-mail confirmée', done: true },
    { icon: 'lucideBuilding2', label: 'Choisir votre espace', done: false },
    { icon: 'lucideHome', label: 'Ajouter un bien ou déposer un dossier', done: false },
  ];

  private platformId = inject(PLATFORM_ID);

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.route.queryParamMap.pipe(take(1)).subscribe(params => {
      const token = params.get('token');
      if (!token) {
        this.status.set('error');
        this.errorMessage.set('Lien de vérification invalide ou expiré.');
        return;
      }

      this.userService.verifyEmail(token).subscribe({
        next: (response) => {
          this.name.set(response.name);
          this.email.set(response.email);
          this.status.set('verified');
        },
        error: (err) => {
          this.status.set('error');
          this.errorMessage.set(err.details);
        }
      });
    });
    }
  }

  onContinue() {
    if (this.userService.getCurrentUserSync()) {
       this.router.navigate(['/setup/profile']);
    } else {
       this.router.navigate(['/signin']);
    }
  }

  onBackToLogin() {
    this.router.navigate(['/signin']);
  }
}
